import { values } from './_helpers'

const _enum = {
  all: 1,
  no: 2,
  yes: 3
}

const toEnum = (value) => value === true ? yesNoAllEnum.yes : value === false ? yesNoAllEnum.no : yesNoAllEnum.all
const fromEnum = (value) => value === yesNoAllEnum.all ? null : Boolean(value - yesNoAllEnum.no)

const yesNoAllEnum = { ..._enum, name: 'yesNoAllEnum', values: values(_enum), toEnum, fromEnum }

export {
  yesNoAllEnum
}
